import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-api-popup',
  templateUrl: './select-api-popup.component.html',
  styleUrls: ['./select-api-popup.component.scss']
})
export class SelectApiPopupComponent implements OnInit {
  form: UntypedFormGroup;
  selectApiOptions: [];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<SelectApiPopupComponent>,
    private translate: TranslateService
  ) {
    this.selectApiOptions = data;
  }

  ngOnInit() {
    console.log('this.selectApiOptions', this.selectApiOptions);
    this.initializeForm();
  }

  private initializeForm() {
    this.form = this.formBuilder.group({
      selectApi: ['', [Validators.required]]
    });
  }

  save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.dialogRef.close(this.form.get('selectApi').value);
    }
  }
}
